"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isDateAllowed;
function isDateAllowed(date, min, max, allowedFn) {
    return (!allowedFn || allowedFn(date)) && (!min || date >= min) && (!max || date <= max);
}
//# sourceMappingURL=isDateAllowed.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/es5/components/VDatePicker/util/isDateAllowed.js
// module id = gsQ5
// module chunks = 36